<template>
    <component :is="template">
        <div class="gift">
            <div>
                <div class="tit-wrap tit-wrap--unberline">
                    <h2 class="tit">캐시선물내역</h2>
                </div>

                <div>
                    <div class="mb-30px mb-md-40px">
                        <v-layout>
                            <v-btn :color="filter.type == 'give' ? 'primary' : 'grey'" :outlined="filter.type == 'give' ? false : true" x-large tile dark elevation="0" class="col-6" @click="filter.type = 'give'; search(true);">보낸내역</v-btn>
                            <v-btn :color="filter.type == 'take' ? 'primary' : 'grey'" :outlined="filter.type == 'take' ? false : true" x-large tile dark elevation="0" class="col-6" @click="filter.type = 'take'; search(true);">받은내역</v-btn>
                        </v-layout>
                    </div>
                </div>
            </div>

            <div class="mt-4">
                <div>
                    <div class="mb-4">
                        <v-row class="row--small">
                            <v-col :cols="$vuetify.breakpoint.mobile ? 12 : 'auto'">
                                <v-sheet :width="$vuetify.breakpoint.mobile ? '100%' : 150">
                                    <v-select v-model="filter.status" :items="statuses" item-text="text" item-value="value" label="상태" persistent-placeholder outlined dense hide-details color="primary" @input="page = 1; search(true)"/>
                                </v-sheet>
                            </v-col>
                            <v-spacer/>
                            <v-col :cols="$vuetify.breakpoint.mobile ? 12 : 'auto'">
                                <v-sheet :width="$vuetify.breakpoint.mobile ? '100%' :180">
                                    <v-select v-model="filter.searchKey" :items="searchKeys" item-text="text" item-value="value" label="검색조건" persistent-placeholder outlined dense hide-details color="primary" @input="filter.searchValue = null"/>
                                </v-sheet>
                            </v-col>
                            <v-col :cols="$vuetify.breakpoint.mobile ? 12 : 'auto'">
                                <v-text-field v-model="filter.searchValue" label="검색어" persistent-placeholder outlined dense hide-details append-icon="mdi-magnify" color="primary" :disabled="!filter.searchKey" @keydown.enter="page = 1; search(true);" @click:append="page = 1; search(true);"/>
                            </v-col>
                        </v-row>
                    </div>
                    <div v-if="filter.type == 'take'">
                        <v-row>
                            <v-col align="right">
                                <v-btn color="primary" @click="allTake">모두받기</v-btn>
                            </v-col>
                        </v-row>
                    </div>
                    <v-divider/>
                    <v-data-table :items="gifts" :headers="giftsHeaders" hide-default-footer disable-pagination disable-sort class="v-data-table--sm">
                        <span slot="item.sender" slot-scope="{item}">{{ item.sender.name }}({{ item.sender.username }})</span>
                        <span slot="item.receiver" slot-scope="{item}">{{ item.receiver.name }}({{ item.receiver.username }})</span>
                        <span slot="item.amount" slot-scope="{item}">{{ item.amount.format() }}</span>

                        <v-btn slot="item.resend" slot-scope="{item}" small block color="primary" @click="resend(item)" :disabled="item.status != `발송` || item.smsLimit <= item.smsCount">재발송 ({{ item.smsCount }}/{{ item.smsLimit }})</v-btn>
                        <v-btn slot="item.cancel" slot-scope="{item}" small block color="primary" @click="cancel(item)" :disabled="[`취소`,`받음`,`거절`].includes(item.status)">선물취소</v-btn>
                        <v-btn slot="item.take" slot-scope="{item}" small block color="primary" @click="take(item)" :disabled="item.status != `발송`">받기</v-btn>
                        <v-btn slot="item.reject" slot-scope="{item}" small block color="primary" @click="reject(item)" :disabled="item.status != `발송`">거절</v-btn>

                        <span slot="item.createdAt" slot-scope="{item}">{{ $dayjs(item.createdAt).format("YYYY-MM-DD HH:mm:ss") }}</span>
                    </v-data-table>
                </div>
            </div>

            <div class="mt-30px mt-md-40px">
                <v-pagination v-model="page" :length="pageCount" total-visible="11" @input="search(true)"/>
            </div>
        </div>
    </component>
</template>
<script>
import api from "@/api";
export default {
    data(){
        return {
            filter: {
                type: "give",
                status: null,
                searchKey: null,
                searchValue: null,
            },

            page: 1,
            pageCount: 0,
            limit: 10,

            gifts: [],

            statuses: [
                { text: ":: 전체상태 ::", value: null },
                { text: "발송", value: "발송" },
                { text: "받음", value: "받음" },
                { text: "취소", value: "취소" },
            ],
        }
    },
    mounted(){
        this.init();
    },
    methods: {
        async init(){
            let { me } = await api.v1.me.profile.get();
            this.me = me;

            this.search(false);
        },
        async search(routable = false){
            if(routable){
                this.$router.push({
                    query: { ...this.filter, page: this.page }
                });
            }

            let { summary, gifts } = await api.v1.me.gifts.gets({
                headers: {
                    skip: (this.page - 1) * this.limit,
                    limit: this.limit
                },
                params: this.filter
            });

            this.gifts = gifts;
            this.pageCount = Math.ceil(summary.totalCount / this.limit);
        },

        async resend(gift){
            await api.v1.me.gifts.resend(gift);
            alert("재발송 되었습니다");
            this.search(false);
        },

        async cancel(gift){
            if(confirm("취소하시겠습니까?")){
                await api.v1.me.gifts.cancel(gift);
                alert("취소 되었습니다");
                this.search(false);
            }
        },

        async reject(gift){
            if(confirm("선물을 거절하시겠습니까?")){
                await api.v1.me.gifts.reject(gift);
                alert("선물 거절하기가 완료되었습니다");
                this.search(false);
            }
        },

        async take(gift){
            if(confirm("선물을 받으시겠습니까?")){
                await api.v1.me.gifts.take(gift);
                alert("선물받기가 완료되었습니다");
                this.search(false);
            }
        },

        async allTake(){
            if(confirm("모든 선물을 받으시겠습니까?")){
                await api.v1.me.gifts.allTake();
                alert("선물받기가 완료되었습니다");
                this.search(false);
            }
        }

    },
    computed: {
        template(){ return () => import(`@/templates/${this.$theme.pages.mypage}`); },
        giftsHeaders(){
            switch(this.filter.type){
                case "give": {
                    return [
                        { text: "받는사람", value: "receiver", align: "center", width: 140 },
                        { text: "연락처", value: "receiver.phone", align: "center" },
                        { text: "선물금액", value: "amount", align: "center" },
                        { text: "선물상태", value: "status", align: "center" },
                        { text: "발송일자", value: "createdAt", align: "center" },
                        { text: "재발송", value: "resend", align: "center" },
                        { text: "취소", value: "cancel", align: "center" },
                    ];
                }
                case "take": {
                    return [
                        { text: "보낸사람", value: "sender", align: "center", width: 140 },
                        { text: "연락처", value: "sender.phone", align: "center" },
                        { text: "선물금액", value: "amount", align: "center" },
                        { text: "선물상태", value: "status", align: "center" },
                        { text: "받은일자", value: "createdAt", align: "center" },
                        { text: "받기", value: "take", align: "center" },
                        { text: "거절", value: "reject", align: "center" }
                    ];
                }
            }
        },

        searchKeys(){
            switch(this.filter.type){
                case "give": {
                    return [
                        { text: ":: 전체검색 ::", value: null },
                        { text: "받는사람 이름", value: "receiver.name" },
                        { text: "받는사람 아이디", value: "receiver.username" },
                        { text: "받는사람 연락처", value: "receiver.phone" },
                    ];
                }
                case "take": {
                    return [
                        { text: ":: 전체검색 ::", value: null },
                        { text: "보낸사람 이름", value: "sender.name" },
                        { text: "보낸사람 아이디", value: "sender.username" },
                        { text: "보낸사람 연락처", value: "sender.phone" },
                    ]
                }
            }
        }
    },
}
</script>